import { httpClient } from '@/api/httpClient';
import {
  mapApiResourceToNotificationPage,
  type NotificationPage,
  type NotificationPageApiResource,
  type UnreadNotificationCountApiResource,
} from './notificationsApi.types';

const NOTIFICATIONS_PATH = '/me/notifications';

export async function fetchNotifications(
  page: number,
  pageSize: number,
  unreadOnly: boolean = false,
  category: string | null = null
): Promise<NotificationPage> {
  const response = await httpClient.get<NotificationPageApiResource>(NOTIFICATIONS_PATH, {
    params: {
      page,
      page_size: pageSize,
      unread_only: unreadOnly,
      category: category === null ? undefined : category,
    },
  });
  return mapApiResourceToNotificationPage(response.data);
}

export async function fetchUnreadNotificationCount(): Promise<number> {
  const response = await httpClient.get<UnreadNotificationCountApiResource>(
    NOTIFICATIONS_PATH + '/unread-count'
  );
  return response.data.unread;
}

export async function markNotificationRead(notificationId: string): Promise<void> {
  await httpClient.post(NOTIFICATIONS_PATH + '/' + notificationId + '/read');
}

export async function markAllNotificationsRead(): Promise<void> {
  await httpClient.post(NOTIFICATIONS_PATH + '/read-all');
}
